import {
   Box,
   Grid,
   List,
   ListItem,
   ListItemText,
   TextField,
   Typography,
} from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { sizes } from "../../setupUtils";
import { setPGState } from "../productGroupSetupSlice";
import { useEffect } from "react";
import dayjs from "dayjs";

export default function CreateEditIndividualSKUDate() {
   const states = useSelector((store) => store.productGroupSetup);
   const { selectedSKUs, createFromDate, createToDate } = states;
   const dispatch = useDispatch();

   const minDate = dayjs().add(1, "day");

   useEffect(() => {
      setInitialDate();
   }, []);

   function setInitialDate() {
      const selSKUs = selectedSKUs.map((item) => {
         if (
            item.hasOwnProperty("effectiveStartDate") &&
            item.hasOwnProperty("effectiveEndDate")
         ) {
            return item;
         }
         return {
            ...item,
            effectiveStartDate: createFromDate,
            effectiveEndDate: createToDate,
         };
      });
      dispatch(setPGState("selectedSKUs", selSKUs));
   }

   function updateFromDate(newDate, productName) {
      const list = selectedSKUs.map((item) => {
         if (item.productName === productName) {
            return {
               ...item,
               effectiveStartDate: newDate,
            };
         }
         return item;
      });
      dispatch(setPGState("selectedSKUs", list));
   }

   function updateToDate(newDate, productName) {
      const list = selectedSKUs.map((item) => {
         if (item.productName === productName) {
            return {
               ...item,
               effectiveEndDate: newDate,
            };
         }
         return item;
      });
      dispatch(setPGState("selectedSKUs", list));
   }

   return (
      <Box sx={{ mt: 4 }}>
         <Box
            sx={{
               bgcolor: "blue.light",
               height: 40,
               pl: 1,
               pt: 1,
               borderRadius: 1,
            }}
         >
            <Typography sx={{ fontWeight: "bold" }}>SKUs</Typography>
         </Box>
         <Box
            sx={{
               height: 360,
               overflow: "auto",
            }}
         >
            {selectedSKUs.map((sku, index) => {
               return (
                  <Grid container columnSpacing={1} sx={{ mt: 1 }} key={index}>
                     <Grid item xs={8}>
                        <Typography  variant="p16w400">
                           {sku.productName}
                        </Typography>
                     </Grid>

                     <Grid item xs={2}>
                        <Box >
                           <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                 minDate={minDate}
                                 label="From"
                                 value={sku.effectiveStartDate}
                                 onChange={(newDate) =>
                                    updateFromDate(newDate, sku.productName)
                                 }
                                 format="DD/MM/YYYY"
                                 renderInput={(params) => (
                                    <TextField
                                       {...params}
                                       size="small"
                                       sx={{ width: sizes.w150 }}
                                    />
                                 )}
                              />
                           </LocalizationProvider>
                        </Box>
                     </Grid>

                     <Grid item xs={2}>
                        <Box sx={{ mr: 0.5 }}>
                           <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                 minDate={minDate}
                                 label="To"
                                 value={sku.effectiveEndDate}
                                 onChange={(newDate) =>
                                    updateToDate(newDate, sku.productName)
                                 }
                                 format="DD/MM/YYYY"
                                 renderInput={(params) => (
                                    <TextField
                                       {...params}
                                       size="small"
                                       sx={{ width: sizes.w150 }}
                                    />
                                 )}
                              />
                           </LocalizationProvider>
                        </Box>
                     </Grid>
                  </Grid>
               );
            })}
         </Box>
      </Box>
   );
}
